/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import $ from "jquery";

const el = {
	productSearch: "#product-search",
	searchResult: ".product-search-result",
};

const onTypeProductSearch = () => {
	$(document).on(
		"input",
		el.productSearch,
		debounce(function (event) {
			const $searchResultWrapper = $(el.searchResult);
			const $searchInput = $(el.productSearch);
			const searchValue = $searchInput.val().trim();

			if (!searchValue.length) {
				$searchResultWrapper.hide().empty();
				return;
			}

			$searchInput
				.closest("div.product-search")
				.append(
					'<span class="loading-indicator"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i><span class="sr-only">Loading...</span></span>'
				);

			$.ajax({
				url: parameters.url_admin_ajax,
				method: "POST",
				data: {
					action: parameters.ajax_search_product.action,
					nonce: parameters.ajax_search_product.nonce,
					search: searchValue,
				},
			})
				.done((res) => {
					$searchResultWrapper.html(res.data.product_element).show();
					// $searchResultWrapper.find("a").each(function () {
					// 	const regex = new RegExp(`(${searchValue})`, "gi");
					// 	const newHtml = $(this)
					// 		.html()
					// 		.replace(regex, '<span class="green">$1</span>');
					// 	$(this).html(newHtml);
					// });

					$searchInput
						.closest("div.product-search")
						.find(".loading-indicator")
						.remove();
				})
				.fail((err) => {
					console.log(err);
				});
		}, 300)
	);
};

const onEnterProductSearch = () => {
	$(document).on('keyup', el.productSearch, (event) => {
        // If the user presses the "Enter" key on the keyboard
        if (event.key == 'Enter' && !event.shiftKey) {
			const domain = $(el.productSearch).attr('domain');
            event.preventDefault();
			window.location.href = domain+'?s='+$(event.target).val();
		}
	})
}

const unfocusEvent = () => {
	var check_div = document.querySelector(el.searchResult);

	function handleClickOutside(event) {
		if (!check_div.contains(event.target)) {
			$(el.searchResult).fadeOut(400);
			// Remove event listeners if you want to prevent additional handling
			document.removeEventListener("click", handleClickOutside);
			document.removeEventListener("touchstart", handleClickOutside);
		}
	}

	function handleMouseLeave() {
		$(el.searchResult).fadeOut(400);
		// Remove event listeners if you want to prevent additional handling
		document.removeEventListener("click", handleClickOutside);
		document.removeEventListener("touchstart", handleClickOutside);
	}

	// Add event listeners
	check_div.addEventListener("mouseenter", () => {
		document.addEventListener("click", handleClickOutside);
		document.addEventListener("touchstart", handleClickOutside); // Handle touch events
	});

	check_div.addEventListener("mouseleave", handleMouseLeave);

	// Ensure `touchstart` is also considered for interactions
	document.addEventListener("touchstart", (event) => {
		if (!check_div.contains(event.target)) {
			$(el.searchResult).fadeOut(400);
		}
	});
};

function debounce(func, delay = 150) {
	let timeoutId;
	return function (...args) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

const init = () => {
	onTypeProductSearch();
	unfocusEvent();
	onEnterProductSearch();
};

try {
	init();
} catch (error) {
	console.log(error);
}
